<template>
  <el-form ref="addFrom" :model="addFrom" :rules="rules" label-width="110px">
    <el-row>
      <div class="tips">成果分享</div>
      <el-col :span="24">
        <el-form-item style="height: 10px" label="课题编号">
          <label>{{ addFrom.cid }}</label>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item style="height: 10px" label="课题负责人">
          <label>{{ addFrom.fzrxm }}</label>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item style="height: 10px" label="课题属性">
          <label>{{ addFrom.ktsx }}</label>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="开始时间" prop="qsrq" key="10">
          <el-date-picker
            type="datetime"
            placeholder="选择日期"
            v-model="addFrom.qsrq"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-row>
          <el-col :span="24">
            <el-form-item label="结束时间" prop="jsrq" key="10">
              <el-date-picker
                type="datetime"
                placeholder="选择日期"
                v-model="addFrom.jsrq"
                :clearable="false"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-form-item label="讲师" prop="fxds">
          <treeselect
            v-model="addFrom.fxds"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 100%; line-height: 18px; margin-top: 4px"
            :limit="1"
            :max-height="200"
          />
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="完成情况" prop="sfwc">
          <el-select
            v-model="addFrom.sfwc"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择完成情况"
          >
            <el-option label="未完成" value="0"></el-option>
            <el-option label="已完成" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <div class="tips">结项情况</div>
      <el-col :span="24">
        <el-form-item label="课题结项确认" prop="sfjx">
          <el-select
            :disabled="addFrom.sfjx == 1"
            v-model="addFrom.sfjx"
            filterable
            default-first-option
            style="width: 100%"
            placeholder="请选择"
          >
            <el-option label="未结项" value="0"></el-option>
            <el-option label="已结项" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-col :span="24">
          <el-form-item label="备注说明">
            <el-input v-model="addFrom.bz"></el-input>
          </el-form-item>
        </el-col>
      </el-col>
    </el-row>
    <el-row>
      <div class="tips">获奖情况</div>

      <el-col
        :span="24"
        v-if="addFrom.ktsx == '院内课题' && addFrom.hjqk != null"
      >
        <el-form-item style="height: 10px" label="获奖情况">
          <label>{{ addFrom.hjqk }}</label>
        </el-form-item>
      </el-col>

      <el-col
        :span="24"
        v-if="addFrom.ktsx != '院内课题' && addFrom.jlqq != null"
      >
        <el-form-item style="height: 10px" label="奖励情况">
          <label>{{ addFrom.jlqq }}</label>
        </el-form-item>
      </el-col>
      <el-col
        :span="24"
        v-if="addFrom.ktsx != '院内课题' && addFrom.jjqk != null"
      >
        <el-form-item style="height: 10px" label="奖金情况">
          <label>{{ addFrom.jjqk }}</label>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="兑现情况" prop="sfbx">
          <el-radio-group v-model="addFrom.sfbx">
            <el-radio :label="0">未兑现</el-radio>
            <el-radio :label="1">已兑现</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getDictData } from "@/api/task.js";
import { formatMomentDate, sizeFormat, checkVal } from "@/utils/utils";
import moment from "moment";
import { getStepShareById, stepShareSave } from "@/api/course.js";
export default {
  name: "shareEdit",
  computed: {
    ...mapGetters(["deptUser"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      addFrom: {
        type: "1",
        id: null,
        qsrq: null,
        jsrq: null,
        fxds: null,
        sfwc: null,
        sfbx: null,
        sfjx: null,
        bz: null,
        cid: this.mxParams.ktbh,

        fzr: null,
        fzrxm: this.mxParams.fzr,
        ktsx: null,
        hjqk: null,
        cgroup: null,
        jlqq: null,
        jjqk: null,
      },
      ktdsOptions: [],

      parentDialog: false,
    };
  },

  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.initData();
  },
  methods: {
    initData() {
      //获取要编辑数据
      let cid = this.mxParams.ktbh;
      const params1 = { cid };
      getStepShareById(params1).then((res) => {
        if (res.code === 0) {
          this.addForm = res.data[0];
          this.addFrom.id = this.addForm.id;
          this.addFrom.qsrq = this.addForm.qsrq;
          this.addFrom.jsrq = this.addForm.jsrq;
          this.addFrom.fxds = this.addForm.fxds;
          this.addFrom.sfwc = this.addForm.sfwc;
          this.addFrom.sfjx = this.addForm.sfjx;
          this.addFrom.bz = this.addForm.bz;
          this.addFrom.sfbx = parseInt(this.addForm.sfbx);

          this.addForm.cgroup = this.addForm.cgroup;
          this.addFrom.ktsx = this.addForm.ktsx;
          this.addFrom.fzr = this.addForm.fzr;
          this.addFrom.hjqk = this.addForm.hjqk;
          this.addFrom.jlqq = this.addForm.jlqq;
          this.addFrom.jjqk = this.addForm.jjqk;
        }
      });
    },
    handleAdd() {
      if (this.addFrom.qsrq != null && this.addFrom.jsrq != null) {
        let qsrq = moment(this.addFrom.qsrq).format("YYYY-MM-DD HH:mm:ss");
        let jsrq = moment(this.addFrom.jsrq).format("YYYY-MM-DD HH:mm:ss");
        if (qsrq > jsrq) {
          this.$message.error("开始时间不能大于结束时间！");
          return false;
        }
        this.addFrom.qsrq = qsrq;
        this.addFrom.jsrq = jsrq;
      }
      const params = { ...this.addFrom };
      stepShareSave(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin-bottom: 20px;
}
</style>